"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const fireCustomEvent = async (event, data) => {
  document.body.dispatchEvent(new CustomEvent("mco-tracking-event", {
    detail: {
      event,
      ...data
    }
  }));
};
var _default = exports.default = fireCustomEvent;